import { Link } from '@tanstack/react-router';
import { usePode } from '@/api/me';
import { ApiError } from '@/lib/api';

/** Mensagem da API que fala em tributos (ex.: "Item sem tributos vigentes na data..."). Só texto: a regra e da API. */
const FALA_EM_TRIBUTOS = /tributos/i;

/** Erro da Formacao/Liberacao: 422 DADOS_AUSENTES cuja mensagem trata de tributos ausentes. */
export function ehErroTributosAusentes(erro: unknown): boolean {
  return erro instanceof ApiError && erro.code === 'DADOS_AUSENTES' && FALA_EM_TRIBUTOS.test(erro.message);
}

/** Indisponibilidade de tabela na Liberacao: motivo TAXES_MISSING, ou DADOS_AUSENTES com a mensagem de tributos. */
export function ehIndisponivelTributos(indisponivel: { code: string; message: string }): boolean {
  return indisponivel.code === 'TAXES_MISSING' || (indisponivel.code === 'DADOS_AUSENTES' && FALA_EM_TRIBUTOS.test(indisponivel.message));
}

/**
 * Link "Cadastrar tributos" para a aba de tributos do item (o padrao da tela de item e a propria aba tributacao).
 * So aparece com item.editar; sem a permissao a tela mostra so o texto do erro, como antes.
 */
export function LinkCadastrarTributos({ itemId }: { itemId: string }) {
  const { pode } = usePode();
  if (!pode('item.editar')) return null;
  return (
    <Link
      to="/cadastros/itens/$id"
      params={{ id: itemId }}
      search={{ aba: 'tributacao' }}
      className="rounded-sm font-medium text-primary underline-offset-2 outline-none hover:underline focus-visible:shadow-focus"
    >
      Cadastrar tributos
    </Link>
  );
}
